import * as types from "./types";
import * as API_URL from "../../../env";

export const login = (payload) => ({
    type: types.LOGIN,
    meta: {
        async: true,
        blocking: true,
        path: "0.0.0.0:8080/back-service/api/v1/public/login",
        method: "POST",
        body: payload
    },
});

export const signup = (payload) => ({
    type: types.INSERT,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/public/signup",
        method: "POST",
        body: payload
    },
});

export const logout = () => ({
    type: types.LOGOUT,
});

export const authenticated = () => ({
    type: types.AUTHENTICATED,
});

export const initializeSession = (payload) => ({
    type: types.INITIALIZE,
    payload
});

export const destroySession = () => ({
    type: types.DESTROY
});

export const forgotPassword = (payload) => ({
    type: types.FORGOT_PASSWORD,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/public/forgot-password",
        method: "POST",
        body: payload
    },
});

export const confirmOTP = (payload) => ({
    type: types.CONFIRM_OTP,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/public/confirm-otp",
        method: "POST",
        body: payload
    },
});

export const resetPassword = (payload) => ({
    type: types.RESET_PASSWORD,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/admin/reset-password",
        method: "POST",
        body: payload
    },
});
export const addLanguage = (payload) => ({
    type: types.ADD_LANGUAGE,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/language/add-language",
        method: "POST",
        body: payload
    },
});
export const getLanguages = (payload) => ({
    type: types.LIST_LANGUAGE,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/language/list-language",
        method: "POST",
        body: payload
    },
});

export const deleteLanguage = (payload) => ({
    type: types.DELETE_LANGUAGE,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/language/delete-language",
        method: "POST",
        body: payload
    },
});

export const changePassword = (payload) => ({
    type: types.CHANGE_PASSWORD,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL + "/public/change-password",
        method: "POST",
        body: payload
    },
});

export const fetchListMenusForRole = (payload) => ({
    type: types.FETCH_MENU_LIST,
    meta: {
        async: true,
        blocking: true,
        path: API_URL.BACKEND_SERVICE_API_URL+"/role/list-portal-menus-for-role",
        method: "POST",
        body: payload
    },
});